export default __webpack_public_path__ + "static/media/mahjong.4bd9b74a.png";